import type { Quote } from "./types";

const convertCurrencyToNumber = (amount: string): number => {
  const cleaned = amount?.replace(/[$£,]/g, "");

  return +(cleaned || Infinity);
};

export const sortByPremium = (a: Quote, b: Quote) => {
  const left = convertCurrencyToNumber(a.premium ?? "0");
  const right = convertCurrencyToNumber(b.premium ?? "0");

  return left - right;
};

export const sortByInstallmentAmount = (a: Quote, b: Quote) => {
  const left = convertCurrencyToNumber(a.installmentsAmount ?? "0");
  const right = convertCurrencyToNumber(b.installmentsAmount ?? "0");

  return left - right;
};
